import React from "react";
import ReactDOM from "react-dom/client";

import * as Sentry from "@sentry/react";

import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";

import App from "./App.tsx";
import { initSentry } from "./sentry";
import { init } from "@plausible-analytics/tracker";
init({
  domain: "villabraou.com",
  outboundLinks: true,
  formSubmissions: true,
});
initSentry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: "2rem", textAlign: "center" }}>
          Something went wrong. Please refresh the page.
        </div>
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
